import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";
import HeroSearchForm from "./HeroSearchForm";
import AnimatedText from "./AnimatedText";

const TABS = [
  { title: "2 BEDROOMS", key: "2 BEDROOMS", content: <HeroSearchForm /> },
  { title: "3 BEDROOMS", key: "3 BEDROOMS", content: <HeroSearchForm /> },
  { title: "4 BEDROOMS", key: "4 BEDROOMS", content: <HeroSearchForm /> },
  { title: "5 BEDROOMS", key: "5 BEDROOMS", content: <HeroSearchForm /> },
];

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const scaleIn = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: { 
    scale: 1, 
    opacity: 1,
    transition: { 
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

export default function HeroSection() {
  const [activeTab, setActiveTab] = useState("buy");

  return (
    <>
      <section className="hero-section hero-section-one" id="home">
        <Container>
          <Row>
            <Col md={12}>
              <div className="hero-section-main-content">
                <motion.div
                  initial="hidden"
                  animate="visible"
                  variants={scaleIn}
                  transition={{
                    type: "spring",
                    stiffness: 100,
                    damping: 15,
                    duration: 1,
                  }}
                >
                  <div className="hero-section-content text-center w-100 position-relative">
                    <Row className="justify-content-center">
                      <Col lg={10} xl={7} xxl={8}>
                        <motion.div className="hover-effect" variants={staggerContainer} initial="hidden" animate="visible">
                          <motion.span className="hero-badge shadow-sm mb-3" variants={fadeInUp}>Love Where You’ll Live </motion.span>
                          <motion.h3 className="hero-title fw-medium display-2 mb-0" variants={fadeInUp} >North BBCreek Townhomes @ Taylor,TX <br/> <AnimatedText text={"TRIVIK BUILDERS"} /> </motion.h3>
                          <motion.p className="fs-18 text-dark mt-4 mx-xxl-5 pt-1 mb-50" variants={fadeInUp}>
                            Explore luxury properties suited to your preferences, ranging from beautiful homes to rewarding investments. Start your adventure with us and unlock the door to your dream property.
                          </motion.p>
                        </motion.div>
                      </Col>
                    </Row>
                    <motion.div className="position-relative mt-2" variants={fadeInUp} initial="hidden" animate="visible" transition={{ delay: 0.4 }}>
                      <ul className="nav nav-tabs justify-content-center hero-tab-filter" role="tablist">
                        {TABS.map((tab) => (
                          <motion.li className="nav-item" role="presentation" key={tab.key}
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                          >
                            <button className={`nav-link ${
                                activeTab === tab.key ? "active" : ""
                              }`}
                              id={`${tab.key}-tab`}
                              data-bs-toggle="tab"
                              type="button"
                              role="tab"
                              onClick={() => setActiveTab(tab.key)}
                            >
                              {tab.title}
                            </button>
                          </motion.li>
                        ))}
                      </ul>

                      <div className="tab-content hero-tab-content">
                        <AnimatePresence mode="wait">
                          {TABS.map(
                            (tab) =>
                              tab.key === activeTab && (
                                <motion.div key={tab.key}
                                  className="tab-pane active"
                                  role="tabpanel"
                                  initial={{ opacity: 0, y: 20 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: -20 }}
                                  transition={{
                                    duration: 0.4,
                                    ease: "easeInOut",
                                  }}
                                >
                                  {tab.content}
                                </motion.div>
                              )
                          )}
                        </AnimatePresence>
                      </div>
                    </motion.div>
                  </div>
                </motion.div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
